<template>
	<div id="bottomCenter">
		<dv-border-box-6>
			<div class="up d-flex jc-around">
				<div class="pt-3">
					<div style="width: 2rem; height: 1.4rem;">
						<dv-charts v-if="bottomCenterData.online" :option="leftOption" style="width: 2rem; height: 1.5rem;" />
					</div>
					<p class="ta-cen" style="font-size: 0.1875rem">在线</p>
				</div>
				<div class="centerText d-flex flex-column jc-evenly pt-3">
					<p class="led">{{ bottomCenterData.device_count }}</p>
					<p>设备管控总量</p>
				</div>
				<div class="pt-3">
					<div style="width: 2rem; height: 1.4rem;">
						<dv-charts v-if="bottomCenterData.running" :option="rightOption" style="width: 2rem; height: 1.5rem;" />
					</div>
					<p class="ta-cen" style="font-size: 0.1875rem">运行</p>
				</div>
			</div>
		</dv-border-box-6>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				leftOption: {},
				rightOption: {},
			};
		},
		components: {

		},
		props: ['bottomCenterData'],
		watch: {
			'bottomCenterData': {
				handler() {
					this.draw();
					// console.log(this.bottomCenterData.online/this.bottomCenterData.device_count*100)
				},
				deep: true
			}
		},
		mounted() {
			
		},
		methods: {
			draw() {
				let online = this.bottomCenterData.online/this.bottomCenterData.device_count*100<=100?
				this.bottomCenterData.online/this.bottomCenterData.device_count*100:0
				let running = this.bottomCenterData.running/this.bottomCenterData.device_count*100<=100?
				this.bottomCenterData.running/this.bottomCenterData.device_count*100:0
				this.leftOption = {
					series: [
						{
							type: 'gauge',
							startAngle: -Math.PI / 2,
							endAngle: Math.PI * 1.5,
							arcLineWidth: 8,
							data: [{
								name: this.bottomCenterData.online,
								value: online,
								gradient: ['#43A1F2', '#45CBE9', '#46D1E8']
							}],
							axisLabel: {
								show: false
							},
							axisTick: {
								show: false
							},
							showEmptyCircle: true,
							pointer: {
								show: false
							},
							radius: ['70%',"75%"],
							dataItemStyle: {
								lineCap: 'round'
							},
							details: {
								show: true,
								formatter: '{name}台',
								style: {
									fill: '#1ed3e5',
									fontSize: 16
								}
							}
						}
					]
				}

				this.rightOption = {
					series: [{
						type: 'gauge',
						startAngle: -Math.PI / 2,
						endAngle: Math.PI * 1.5,
						arcLineWidth: 8,
						data: [{
							name: this.bottomCenterData.running,
							value: running,
							gradient: ['#5BCC7C']
						}],
						axisLabel: {
							show: false
						},
						axisTick: {
							show: false
						},
						showEmptyCircle: true,
						pointer: {
							show: false
						},
						dataItemStyle: {
							lineCap: 'round'
						},
						radius: ['70%',"75%"],
						details: {
							show: true,
							formatter: '{name}台',
							style: {
								fill: '#1ed3e5',
								fontSize: 16
							}
						}
					}]
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	#bottomCenter {
		width: 11.9125rem;
		height: 2rem;
		.up {
			width: 100%;
			height: 1.9375rem;

			.centerText {
				text-align: center;
				color: white;

				.led {
					background: url('~@/assets/shuziping.png') no-repeat 100% 0;
					background-size: cover;
					width: 5rem;
					height: 1rem;
					line-height: 1rem;
					font-weight: 100;
					font-family: 'HarmonyOSSans';
					// font-family: 'led regular';
					font-size: 0.625rem;
					text-align: center;
					letter-spacing: 5px;
				}

				p {
					font-size: 0.25rem;
					font-weight: bold;
				}
			}
		}
	}
</style>
